// The navbar credit figure. The AI endpoints all return what is left after a
// call, so the toolbar can stay honest without waiting for the next page load.
// A null or undefined figure means the server is not charging this user —
// admins — so the display is left alone.
export function updateCreditsDisplay(remaining) {
  if (remaining === null || remaining === undefined) return;

  const el = document.getElementById('navbar-credits-value');
  if (el) el.textContent = Number(remaining).toLocaleString();
}
